import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, queryClient } from '@/lib/platform';

import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { routeTree } from './routeTree.gen';
import { ErrorState } from './components/shared/error-state';
import { initTheme } from './lib/use-theme';

initTheme();

const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => <ErrorState error={error} />,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
